//widgets/_new/cards/vendors/distribution/AverageOrderValueCard.tsx

import React, { FC, useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBox } from '@fortawesome/free-solid-svg-icons'

interface Props {
  totalOrders: number          // NEW: total # of orders
  totalValue: number           // NEW: $ value of *all* orders
}

export const AverageOrderValueCard: FC<Props> = ({ totalOrders, totalValue }) => {
  const avg = useMemo(
    () => (totalOrders ? totalValue / totalOrders : 0),
    [totalOrders, totalValue]
  )

  return (
    <div
      className='card d-flex flex-column h-auto'
      style={{ background: 'linear-gradient(45deg,#27A47C,#6FE594)' }}
    >
      <div className='h-auto rounded-top p-4'>
        <header style={{ fontSize: '2.5rem' }}>
          <FontAwesomeIcon icon={faBox} />
        </header>

        <div className='pt-3 pb-1 d-flex flex-column'>
          <div
            className='fw-bolder'
            style={{ fontSize: '4rem', lineHeight: 1 }}
          >
            {totalOrders.toLocaleString()}
          </div>
          <div
            className='pt-2 fw-bold'
            style={{ fontSize: '1.15rem' }}
          >
            Total&nbsp;Orders&nbsp;YTD
          </div>
        </div>
      </div>

      <div
        style={{
          height: 1,
          width: 'auto',
          margin: '0 50% 0 5%',
          background: 'rgba(255,255,255,0.5)',
        }}
      />

      <footer className='h-auto rounded-bottom pt-4 pb-4 px-4'>
        <div className='d-flex flex-column'>
          <div className='fs-1 fw-bold'>
            ${Math.round(avg).toLocaleString()}
          </div>
          <div className='text-body-secondary fw-bold'>
            Average&nbsp;Order&nbsp;Value
          </div>
        </div>
      </footer>
    </div>
  )
}
